import React from 'react';
import I18n from 'i18n-js';
import { RCModal } from '@reverbdotcom/cadence/components';
import PacklinkAuthorizeAccountOrCreateDraft from './packlink_authorize_account_or_create_draft';

interface Props {
  isOpen: boolean;
  onRequestClose(): void;
  onAuthSuccess?(): void;
  onDraftSuccess?(): void;
  orderId?: string;
}

export default function PacklinkModal(props: Props) {
  const {
    isOpen,
    onRequestClose,
    onAuthSuccess,
    onDraftSuccess,
    orderId,
  } = props;

  return (
    <RCModal
      isOpen={isOpen}
      onOpenChange={(open) => { if (!open) onRequestClose(); }}
      title={I18n.t('discovery.packlink.modalTitle')}
    >
      <PacklinkAuthorizeAccountOrCreateDraft
        onAuthSuccess={onAuthSuccess}
        onDraftSuccess={onDraftSuccess}
        orderId={orderId}
      />
    </RCModal>
  );
}
